import React, { useEffect, useRef } from 'react';
import { CALENDLY_URL } from '../lib/calendly';

// Inline Calendly scheduler. Re-initializes each time it mounts so it works
// correctly inside a tabbed / conditionally-rendered container in an SPA.
export default function CalendlyInline() {
  const ref = useRef(null);

  useEffect(() => {
    const tryInit = () => {
      if (window.Calendly && ref.current) {
        ref.current.innerHTML = '';
        window.Calendly.initInlineWidget({
          url: `${CALENDLY_URL}&background_color=0d1612&text_color=f8fafc&primary_color=10b981`,
          parentElement: ref.current,
        });
        return true;
      }
      return false;
    };

    if (!tryInit()) {
      const interval = setInterval(() => {
        if (tryInit()) clearInterval(interval);
      }, 300);
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="calendly-inline-widget rounded-2xl overflow-hidden"
      style={{ minWidth: '320px', height: '650px' }}
      data-testid="calendly-inline"
    />
  );
}
